import { useFormContext } from 'react-hook-form';

import { TextArea } from 'src/components/pages/Portfolio/styles';

const PortfolioIntroduction = ({ registerName }: { registerName: string }) => {
  const methods = useFormContext();

  return (
    <>
      <TextArea
        placeholder="수업 횟수를 입력해 주세요"
        maxLength={1000}
        {...methods.register(registerName)}
      />
    </>
  );
};

export default PortfolioIntroduction;
